<template>
  <div>
    <multiselect
        style=" float: left; width: 94%;"
        id="pcodeSelect"
        v-model="selectedPcodes"
        :options="options"
        :multiple="true"
        :taggable="false"
        @tag="choosePcodeType"
        @search-change="asyncSearchPcode"
        @open="updatePcodeList"
        @close="closeDropdown"
        @remove="onRemove"
        @select="onSelectPCode"
        tag-placeholder=" 新規個人コードの追加"
        :show-labels="false"
        :block-keys="keyLock"
        select-label=""
        remove-label=""
        :placeholder="inputPlaceholder"
        :hide-selected="true"
        :show-no-options="false"
        :max-height="140"
        :disabled="isDisabled"
        :internal-search="true"
        :clearOnSelect="false"
        :closeOnSelect="false"
        :preserve-search="true"
        pre
        :max="maxSelected"
        ref="multiselect"
        label="pCodeId"
        track-by="pCodeId">
        <template slot="option" slot-scope="props">
            <span v-if="props.option.isTag !== true">
                {{props.option.pCodeId}}
                ＜{{getPcodeType(props.option.type)}}＞
            </span>
            <span>
                <span v-if="props.option.isTag !== true && props.option.userId !== ''">（{{ props.option.userId }}）</span>
                <span v-if="props.option.isTag === true">{{ props.search }}</span>
            </span>
        </template>
        <template slot="tag" slot-scope="props">
          <span class="multiselect__tag" v-if="props.option.isNew === 1" style="background: #007f41">
            <span>{{props.option.pCodeId}}
              ＜{{getPcodeType(props.option.type)}}＞
              <span v-if="props.option.userId !== undefined && props.option.userId !== '' ">（{{ props.option.userId }}）</span>
            </span>
            <i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon" style="background: #007f41"></i>
          </span>
          <span class="multiselect__tag" v-else style="background: #468fcc">
            <span>{{props.option.pCodeId}}
              ＜{{getPcodeType(props.option.type)}}＞
              <span v-if="props.option.userId !== undefined && props.option.userId !== ''">（{{ props.option.userId }}）</span>
            </span>
            <i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon" style="background: #468fcc"></i>
          </span>
        </template>
        <div slot="noResult"  class="noResult" @click="choosePcodeType(newPcodeId)">{{newPcodeId}} <span style="float:right; font-size:14px">新規個人コードの追加</span></div>
        <span slot="maxElements" style="color:red">設定上限を超えております。</span>
    </multiselect>
    <div style=" float: right; width: 5%;">
      <i id="pcode-reload" style="font-size: 24px;color: #000000;padding-top: 7px;padding-left: 10px; float:left" class="glyphicon glyphicon-refresh" v-if="isDisabled && isPCodeFinishGet" @click="reloadPcodeList()"></i>
    </div>
    <div id="confirm-lowercase" class="modal fade custom-m" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="smaller lighter frofile-title no-margin">個人コード登録</h3>
          </div>
          <div class="modal-body">
            <div>
              カード番号に半角英字の小文字が含まれております。<br>
              小文字が含まれているとカードが正常に読み込まれません。<br>
              小文字が含まれているかを確認してください。
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-green" style="width:100px" data-dismiss="modal" @click="noChoice()">見直す</button>
            <button class="btn btn-red" style="width:250px" data-dismiss="modal" @click="yesChoice()" >小文字が含まれていても登録する</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <div id="pcode-type" class="modal fade custom-m" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close"  @click="closePopup()" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">個人コード種別の選択</h3>
          </div>
          <div class="modal-body">
            <p id='pcode-add-message'></p>
            <div class="form-group">
                <label class="col-sm-3 control-label no-padding-right" style="padding-top: 4px;" for="form-field-1">コード種別</label>
                <div class="col-sm-9">
                    <select class="form-control" data-placeholder="ユーザー選択" v-model="newPcodeType">
                    <option v-for="item in listType" v-bind:value="item.value" v-bind:key="item.value">
                        {{ item.text }}
                    </option>
                    </select>
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" @click="validateBeforeSubmit()">選択</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import * as Config from '../../config'
import multiselect from 'vue-multiselect'

export default {
  components: { multiselect },
  props: [
    'userId',
    'pcodeErrorMessage',
    'isPCodeFinishGet',
    'isPcodeFinishAdd',
    'PcodeSubmittedFail',
    'loading',
    'startAddPcode',
    'resetDataGroupPcode',
    'assignedPcode'],
  data () {
    return {
      options: [],
      selectedPcodes: [],
      pCodeList: [],
      listType: [
        { text: 'NFCカード', value: 0 },
        { text: 'テンキー入力', value: 1 }
      ],
      pCodeListPages: 1,
      currentPCodePage: 1,
      newPcodeId: '',
      newPcodeType: 0,
      PcodeAddFail: [],
      isDisabled: true,
      inputPlaceholder: '個人コードを選択してください。新しく個人コードを作成する場合は新規個人コードを入力してください。',
      exePcodeAdd: 0,
      flagU: true,
      maxSelected: 20,
      keyLock: []
    }
  },
  created () {
    this.reloadPcodeList()
  },
  mounted () {
    const vm = this
    $('#pcodeSelect').css('display', 'none') // Hide completely input
    var classname = document.getElementById('pcodeSelect')
    classname.addEventListener('keydown', function (e) {
      var key = e.which || e.keyCode
      if (key === 13) { // 13 is enter
        const check = $('#pcode-selection-container li.multiselect__element')
        if (check.length === 0) {
          vm.choosePcodeType(vm.newPcodeId)
        }
      }
    })
  },
  watch: {
    resetDataGroupPcode: function (newVal, oldVal) {
      if (newVal) {
        this.reloadPcodeList()
      }
    },
    startAddPcode: function (newVal, oldVal) {
      if (newVal) {
        this.exePcodeAdd = 1
      } else {
        this.exePcodeAdd = 0
      }
    },
    exePcodeAdd: function (newVal, oldVal) {
      if (newVal > 0) {
        if (newVal <= this.selectedPcodes.length) {
          if (this.selectedPcodes[oldVal].isNew !== undefined) {
            this.pcodeAdd(this.userId, this.selectedPcodes[oldVal].pCodeId, this.selectedPcodes[oldVal].type)
          } else {
            this.pcodeEdit(this.userId, this.selectedPcodes[oldVal].pCodeId)
          }
        } else {
          this.$emit('update:isPcodeFinishAdd', true)
          this.$emit('update:PcodeSubmittedFail', this.PcodeAddFail)
        }
      }
    },
    selectedPcodes: function (newVal, oldVal) {
      var asPcode = this.selectedPcodes.filter(pCode => (pCode.userId !== undefined && pCode.userId !== ''))
      this.$emit('update:assignedPcode', asPcode)
    }
  },
  methods: {
    getPcodeType (type) {
      if (type === 1) {
        return 'テンキー入力'
      }
      if (type === 0) {
        return 'NFCカード'
      }
    },
    choosePcodeType (pCodeId) {
      this.newPcodeId = pCodeId
      this.newPcodeType = 0
      if (this.newPcodeId.toUpperCase() !== this.newPcodeId) {
        $('#confirm-lowercase').modal({
          backdrop: 'static'
        })
      } else {
        $('#pcode-type').modal({
          backdrop: 'static',
          keyboard: false
        })
        this.keyLock = ['Enter']
      }
    },
    validateBeforeSubmit () {
      this.flagU = true
      var pCodeId = this.newPcodeId
      var type = this.newPcodeType
      if (pCodeId !== null && pCodeId !== '') {
        // if pCodeId is input
        // if type is numeric keypad and not number then isNotNumeric = true
        var isNumericKey = type === 1 && !(/^[0-9]{4,20}$/.test(pCodeId))
        var isNFCKey = type === 0 && !(/^[a-zA-Z0-9]{4,20}$/.test(pCodeId))
        if (isNumericKey || isNFCKey) {
          // default is NFC card
          var message = 'NFCカードは半角英数字を組み合わせた4文字以上20文字以内で入力してください。'
          if (type === 1) {
            // 1: 0 indicates NFC and 1 indicates numeric keypad.
            message = 'テンキーは半角数字を4文字以上20文字以内で入力してください。'
          }
          this.$emit('update:pcodeErrorMessage', message)
          this.flagU = false
        }
      }
      this.isEnabledSave = false
      this.closePopup()
      if (this.flagU) {
        this.addNewPcode()
      }
    },
    addNewPcode () {
      const pCode = {
        pCodeId: this.newPcodeId,
        type: this.newPcodeType,
        isNew: 1
      }
      this.selectedPcodes.push(pCode)
      this.pCodeList.unshift(pCode)
      this.closePopup()
    },
    asyncSearchPcode (query) {
      query = query.trim()
      if (query !== '') {
        this.newPcodeId = query
      }
      if (query !== '') {
        this.options = this.pCodeList.filter(function (pcode) {
          if (pcode.userId !== undefined) {
            return (pcode.pCodeId.toLowerCase().includes(query.toLowerCase()) || pcode.userId.toLowerCase().includes(query.toLowerCase()))
          }
          return (pcode.pCodeId.toLowerCase().includes(query.toLowerCase()))
        })
      } else if (query === '') {
        this.options = this.pCodeList
      }
    },
    reloadPcodeList () {
      this.$emit('update:isPCodeFinishGet', false)
      this.selectedPcodes = []
      this.pCodeList = []
      this.options = []
      this.PcodeAddFail = []
      this.getPCodeList(1)
    },
    updatePcodeList (id) {
      this.$emit('update:pcodeErrorMessage', '')
      this.options = this.pCodeList
      $('#pcodeSelect').css('display', 'unset') // Show input
    },
    closeDropdown (value, id) {
      $('#pcodeSelect').css('display', 'none') // Hide completely input
    },
    closePopup () {
      $('#pcode-type').modal('hide')
      this.isDisabled = false
      this.keyLock = []
    //   this.$emit('update:PcodeButtonDisable', false)
    },
    getPCodeList (page) {
      // this.$emit('update:loading', true)
      this.$http.get(Config.PCODE_LIST_API + '?limit=1000&page=' + page + '&sortKey=desc:registered&isValid=true')
        .then(response => {
          this.inputPlaceholder = '個人コードを選択してください。新しく個人コードを作成する場合は新規個人コードを入力してください。'
          if (response.body.maxRecords > 0) {
            this.pCodeListPages = Math.ceil((response.body.maxRecords) / 1000)
            this.currentPCodePage++
            response.body.pCodes.forEach(pCode => {
              this.pCodeList.push(pCode)
            })
            if (this.pCodeListPages > 1 && this.currentPCodePage <= this.pCodeListPages) {
              this.getPCodeList(this.currentPCodePage)
            } else {
              this.isDisabled = false
              this.$emit('update:isPCodeFinishGet', true)
            }
          } else {
            this.isDisabled = false
            this.$emit('update:isPCodeFinishGet', true)
            this.pCodeList = []
            this.pCodeListPages = 0
          }
        })
        .catch((error) => {
          this.inputPlaceholder = '該当するデーターがありません。'
          this.$emit('update:isPCodeFinishGet', true)
          this.pCodeList = []
          this.options = []
          this.isDisabled = true
          console.log(error)
        })
    },
    pcodeEdit (userId, pCodeId) {
      var vm = this
      const Infor = {
        userId: userId
      }
      this.$http.put(Config.PCODE_LIST_API + '/' + encodeURIComponent(pCodeId), Infor)
        .then(response => {
          console.log(response)
          this.exePcodeAdd++
        })
        .catch((error) => {
          vm.PcodeAddFail.push(pCodeId)
          vm.exePcodeAdd++
          console.log(error)
        })
    },
    pcodeAdd (userId, pCodeId, type) {
      var vm = this
      const Infor = {
        userId: userId,
        pCodeId: pCodeId,
        type: parseInt(type),
        isValid: true
      }
      console.log(Infor)
      this.$http.post(Config.PCODE_LIST_API, Infor)
        .then(response => {
          console.log(response)
          this.exePcodeAdd++
        })
        .catch((error) => {
          switch (error.status) {
            case 409:
              vm.pcodeEdit(userId, pCodeId)
              break
            default:
              vm.PcodeAddFail.push(pCodeId)
              vm.exePcodeAdd++
              console.log(error)
              break
          }
          console.log(error)
        })
    },
    onRemove (RemovingPcode, id) {
      if (RemovingPcode.isNew === 1) {
        this.pCodeList.splice(this.pCodeList.indexOf(RemovingPcode), 1)
      }
      this.options = this.pCodeList
    },
    onSelectPCode () {
      this.$emit('update:pcodeErrorMessage', '')
    },
    yesChoice () {
      $('#pcode-type').modal({
        backdrop: 'static',
        keyboard: false
      })
      this.keyLock = ['Enter']
    },
    noChoice () {
      this.$refs.multiselect.activate()
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>
<style>
#pcode-type .modal-body {
    height: 110px;
    overflow-y: auto;
  }
  #pcode-type .modal-content {
    width: 360px;
    overflow-y: auto;
  }
  #pcode-type .modal-header h3.frofile-title{
    padding-bottom: 10px
  }
 #pcode-type .modal-footer {
     padding-bottom: 9px;
    }
  #pcode-type .modal-header {
    padding: 10px 15px;
  }
  #pcode-type{
    z-index: 9999999;
  }
  #pcode-type .modal-dialog {
    position: relative;
    margin: 0px auto;
    top: 33%;
    left: 204px;
}
/* Custom  */
.multiselect__option--highlight {
  background: #1e90ff !important;
}
.multiselect__option--highlight::after {
  background: #1e90ff !important;
}
.multiselect__placeholder {
    color: #adadad;
    display: inline-block;
    margin-bottom: 3px;
}
.multiselect__tags {
    min-height: 30px;
    padding: 2px 40px 0 8px;
    font-size: 14px;
    margin-bottom: 0px !important;
    margin-top: 4px !important;
    border-radius: 0px;
}
.multiselect__tag {
    margin-bottom: 0px;
    margin-top: 4px;
}
.multiselect__select {
    height: 33px;
    top: 4px;
}
#pcode-reload:active {
  color: #a7a7a7 !important
}
.multiselect__tag-icon:focus{
    outline: none;
    color: #377351;
}
.multiselect__tags span {
    max-width: 600px;
}
.multiselect__placeholder {
    max-width: 100% !important;
}
@media only screen and (max-width: 1024px) {
  .multiselect__tags span {
    max-width: 320px;
  }
}
@media only screen and (max-width: 1366px) and (min-width: 1024px) {
  .multiselect__tags span {
    max-width: 400px;
  }
}
.btn-red {
  background-color: red !important;
  border-color: transparent !important;
}
.btn-green {
  background-color: green !important;
  border-color: transparent !important;
}
span:has(.noResult){
  background: #1e90ff !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserPcodeSelect.vue